/* eslint-disable react-refresh/only-export-components */
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import DestructiveActionModal, { REASON_MIN_LENGTH } from '../components/admin/DestructiveActionModal.jsx';

const DestructiveActionContext = createContext(null);

export function DestructiveActionProvider({ children }) {
  const [state, setState] = useState(null);

  const requestDestructiveAction = useCallback((options) => {
    return new Promise((resolve) => {
      setState({
        title: options.title || '操作の確認',
        message: options.message || '',
        confirmLabel: options.confirmLabel || '削除する',
        reason: '',
        resolve,
      });
    });
  }, []);

  const close = useCallback(() => {
    setState((prev) => {
      prev?.resolve?.(null);
      return null;
    });
  }, []);

  const handleConfirm = useCallback(() => {
    setState((prev) => {
      if (!prev) return prev;
      const reason = (prev.reason || '').trim();
      if (reason.length < REASON_MIN_LENGTH) return prev;
      prev.resolve({ reason });
      return null;
    });
  }, []);

  const setReason = useCallback((reason) => {
    setState((prev) => (prev ? { ...prev, reason } : prev));
  }, []);

  const value = useMemo(() => ({ requestDestructiveAction }), [requestDestructiveAction]);

  return (
    <DestructiveActionContext.Provider value={value}>
      {children}
      <DestructiveActionModal
        open={Boolean(state)}
        title={state?.title}
        message={state?.message}
        confirmLabel={state?.confirmLabel}
        reason={state?.reason}
        onReasonChange={setReason}
        onClose={close}
        onConfirm={handleConfirm}
      />
    </DestructiveActionContext.Provider>
  );
}

export function useDestructiveAction() {
  const ctx = useContext(DestructiveActionContext);
  if (!ctx) {
    throw new Error('useDestructiveAction must be used within DestructiveActionProvider');
  }
  return ctx;
}
